import mongoose from 'mongoose';
import exchangeRate, { IExchangeRatesDocument } from '../schemas/exchange-rate';

export default (mongoose.models.ExchangeRate ||
  mongoose.model<IExchangeRatesDocument>('ExchangeRate', exchangeRate)) as mongoose.Model<
  IExchangeRatesDocument
>;
